import PruebaIcon from "../assets/svg/layout/prueba.svg";
import DashboardIcon from "../assets/svg/layout/dashboard.svg";
import DashboardLightIcon from "../assets/svg/layout/dashboard_light.svg";
import MoneyIcon  from "../assets/svg/layout/money.svg";
import MoneyLightIcon  from "../assets/svg/layout/money_light.svg";
import DownloadIconMini from "../assets/svg/layout/download_mini.svg";
import DownloadIconMiniLight from "../assets/svg/layout/download_mini_light.svg";
import TravelIcon from "../assets/svg/layout/travel.svg";
import TravelIconLight from "../assets/svg/layout/travel_light.svg";
import FolderHSEIcon from "../assets/svg/components/folder_hse_dark.svg";
import FolderHSEIconLight from "../assets/svg/components/folder_hse_white.svg";
import BellIcon from "../assets/svg/layout/bell.svg";
import BellLightIcon from "../assets/svg/layout/bell_light.svg";
import BellINotificationcon from "../assets/svg/layout/bell_notification.svg";
import BellLightNotificationIcon from "../assets/svg/layout/bell_notification_light.svg";
import FolderLogisticsIcon from "../assets/svg/components/folder_logistics_dark.svg";
import FolderLogisticsIconLight from "../assets/svg/components/folder_logistics_white.svg";
import OperationsIcon from "../assets/svg/layout/operations.svg";
import OperationsLightIcon from "../assets/svg/layout/operations_light.svg";
import FolderTrasportIcon from "../assets/svg/components/folder_transport_dark.svg";
import FolderTrasportIconLight from "../assets/svg/components/folder_transport_white.svg";
import CarIcon from "../assets/svg/layout/car.svg";
import CarLightIcon from "../assets/svg/layout/car_light.svg";
import TrackingIcon from "../assets/svg/layout/tracking.svg";
import TrackingLightIcon from "../assets/svg/layout/tracking_light.svg";
import LocationReportIcon from "../assets/svg/layout/location_report.svg";
import LocationReportLightIcon from "../assets/svg/layout/location_report_light.svg";
import VehicleValidationIcon from "../assets/svg/layout/validacion_vehicular.svg";
import VehicleValidationLightIcon from "../assets/svg/layout/validacion_vehicular_light.svg";

import FolderMonitoringIcon from "../assets/svg/components/folder_monitoring_dark.svg";
import FolderMonitoringIconLight from "../assets/svg/components/folder_monitoring_white.svg";
import PointIcon from "../assets/svg/layout/point.svg";
import PointLightIcon from "../assets/svg/layout/point_light.svg";
import TrendIcon from "../assets/svg/layout/trend.svg";
import TrendLightIcon from "../assets/svg/layout/trend_light.svg";
import ReturnIcon from "../assets/svg/layout/return.svg";
import ReturnLightIcon from "../assets/svg/layout/return_light.svg";

import MessageIcon from "../assets/svg/layout/message.svg";
import MessageLightIcon from "../assets/svg/layout/message_light.svg";
import PeopleIcon from "../assets/svg/layout/people.svg";
import PeopleLightIcon from "../assets/svg/layout/people_light.svg";


import PanelLeftIcon from "../assets/svg/layout/panel_left.svg";
import PanelLeftLightIcon from "../assets/svg/layout/panel_left_light.svg";
import PanelRightIcon from "../assets/svg/layout/panel_right.svg";
import PanelRightLightIcon from "../assets/svg/layout/panel_right_light.svg";
import FlagIcon from "../assets/svg/layout/flag.svg";
import FlagLightIcon from "../assets/svg/layout/flag_light.svg";
import OffIcon from "../assets/svg/layout/off.svg";
import OffLightIcon from "../assets/svg/layout/off_light.svg";
import ClockIcon from "../assets/svg/layout/clock.svg";
import ClockLightIcon from "../assets/svg/layout/clock_light.svg";
import FolderIcon from "../assets/svg/components/folder_dark.svg";
import FolderIconLight from "../assets/svg/components/folder_white.svg";
import WhatsAppIcon from "../assets/svg/layout/whatsapp.svg";

export const logoutRoute = {
  path: "/",
  name: "Cerrar Sesión",
  icon: OffIcon,
  iconLight: OffLightIcon,
};

export const hidePanelRoute = {
  name: "Ocultar panel",
  icon: PanelLeftIcon,
  iconLight: PanelLeftLightIcon,
};

export const showPanelRoute = {
  name: "Mostrar panel",
  icon: PanelRightIcon,
  iconLight: PanelRightLightIcon,
};

export const helpRoute = {
  path: "/help",
  name: "Recursos",
  icon: FlagIcon,
  iconLight: FlagLightIcon,
};

export const menuRoutes = {
  Admin: [
    // Rutas principales que quedan en el primer nivel
    {
      path: "/dashboard",
      name: "Dashboard",
      icon: DashboardIcon,
      iconLight: DashboardLightIcon,
    },
    {
      path: "/transport-calculator",
      name: "Calcular trasporte",
      icon: MoneyIcon,
      iconLight: MoneyLightIcon,
    },
    {
      path: "/satellite-uploader",
      name: "Añadir reportes",
      icon: DownloadIconMini,
      iconLight: DownloadIconMiniLight,
    },
    {
      path: "/geofences-travel-and-more",
      name: "Rutas de viajes",
      icon: TravelIcon,
      iconLight: TravelIconLight,
    },
    // Carpeta de Recursos Humanos
    {
      name: "HSQ",
      icon: FolderHSEIcon,
      iconLight: FolderHSEIconLight,
      isFolder: true,
      children: [
        {
          path: "/alerts-persons",
          name: "Alertas",
          icon: BellIcon,
          iconLight: BellLightIcon,
        },
        {
          path: "/persons",
          name: "Personas",
          icon: PeopleIcon,
          iconLight: PeopleLightIcon,
        },
      ],
    },
    // Carpeta de LOgistica
    {
      name: "Logistica",
      icon: FolderLogisticsIcon,
      iconLight: FolderLogisticsIconLight,
      isFolder: true,
      children: [
        {
          path: "/scheduler",
          name: "Operaciones",
          icon: OperationsIcon,
          iconLight: OperationsLightIcon,
        },
      ],
    },

    // Carpeta de Vehículos
    {
      name: "Transporte",
      icon: FolderTrasportIcon,
      iconLight: FolderTrasportIconLight,
      isFolder: true,
      children: [
        {
          path: "/alerts-vehicles",
          name: "Alertas",
          icon: BellIcon,
          iconLight: BellLightIcon,
        },
        {
          path: "/vehicles",
          name: "Vehiculos",
          icon: CarIcon,
          iconLight: CarLightIcon,
        },
        {
          path: "/vehicle-tracking",
          name: "Seguimiento vehicular",
          icon: TrackingIcon,
          iconLight: TrackingLightIcon,
        },
        {
          path: "/location-reports",
          name: "Reportes de ubicacion",
          icon: LocationReportIcon,
          iconLight: LocationReportLightIcon,
        },
        {
          path: "/validate-vehicle-inspection",
          name: "Validacion vehicular",
          icon: VehicleValidationIcon,
          iconLight: VehicleValidationLightIcon,
        },
      ],
    },

    // Carpeta de Monitoreo
    {
      name: "Monitoreo",
      icon: FolderMonitoringIcon,
      iconLight: FolderMonitoringIconLight,
      isFolder: true,
      children: [
        {
          path: "/hotspots",
          name: "Puntos Criticos",
          icon: PointIcon,
          iconLight: PointLightIcon,
        },

        {
          path: "/trends",
          name: "Tendencias",
          icon: TrendIcon,
          iconLight: TrendLightIcon,
        },
        
        {
          path: "/repeat-offenders",
          name: "Reincidentes",
          icon: ReturnIcon,
          iconLight: ReturnLightIcon,
        },
      ],
    },
    {
      path: "/wssp-connection",
      name: "Conexion WhatsApp",
      icon: WhatsAppIcon,
      iconLight: WhatsAppIcon,
    },
        {
      path: "/message",
      name: "Mensajes",
      icon: MessageIcon,
      iconLight: MessageLightIcon,
    },
  ],
  Vehiculos: [
    {
      path: "/dashboard",
      name: "Dashboard",
      icon: DashboardIcon,
      iconLight: DashboardLightIcon,
    },
    {
      path: "/mis-vehiculos",
      name: "Mis Vehículos",
      icon: CarIcon,
      iconLight: CarLightIcon,
    },
    {
      path: "/carriers",
      name: "Transportistas",
      icon: PeopleIcon,
      iconLight: PeopleLightIcon,
    },
    {
      path: "/mis-reportes",
      name: "Mis Reportes",
      icon: DownloadIconMini,
      iconLight: DownloadIconMiniLight,
    },
    {
      path: "/perfil",
      name: "Mi Perfil",
      icon: PeopleIcon,
      iconLight: PeopleLightIcon,
    },
  ],
  Terceros: [
    {
      path: "/dashboard",
      name: "Dashboard",
      icon: DashboardIcon,
      iconLight: DashboardLightIcon,
    },
    {
      path: "/reportes-asignados",
      name: "Reportes Asignados",
      icon: DownloadIconMini,
      iconLight: DownloadIconMiniLight,
    },
    {
      path: "/perfil",
      name: "Mi Perfil",
      icon: PeopleIcon,
      iconLight: PeopleLightIcon,
    },
  ],
  RRHH: [
    {
      path: "/dashboard",
      name: "Dashboard",
      icon: DashboardIcon,
      iconLight: DashboardLightIcon,
    },
    {
      path: "/persons",
      name: "Personas",
      icon: PeopleIcon,
      iconLight: PeopleLightIcon,
    },
    {
      path: "/geofences-travel-and-more",
      name: "Rutas de viajes",
      icon: TravelIcon,
      iconLight: TravelIconLight,
    },
    {
      path: "/message",
      name: "Mensajes",
      icon: MessageIcon,
      iconLight: MessageLightIcon,
    },
  ],
};
